module.exports = __webpack_public_path__ + "media/images/mobile-only/element06-941b6e3dcdf72ad952c0d7d209eac03d.png";